<template>
  <mdb-container fluid>
    <mdb-row v-if="isoCode && isoCode != 'no-coverage'">
      <mdb-col>
        <h4>
          <u>
            <a :href="'#' + isoCode">
              <mdb-icon size="xs" icon="link" />{{ products[isoCode].name }}</a
            ></u
          >
        </h4>
        <Panel :product="products[isoCode]" :isoCode="isoCode"></Panel>
      </mdb-col>
    </mdb-row>
    <mdb-row v-else-if="isoCode == 'no-coverage'">
      <mdb-col>
        <h4>No Coverage there !</h4>
        <img
          class="no-coverage"
          src="https://thumbs.gfycat.com/JoyousImpassionedBigmouthbass-small.gif"
          alt=""
        />
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import { getProducts } from "../common/dataSourceIntegrationService.js";
import Panel from "./Panel.vue";
export default {
  name: "StateDetails",
  props: {},
  data() {
    return {};
  },
  computed: {
    isoCode: function() {
      return this.$route.params.isoCode;
    },
    products: function() {
      return getProducts();
    }
  },
  components: {
    Panel
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.no-coverage {
  position: relative;
  height: 50%;
  width: 50%;
}
</style>
